export default __webpack_public_path__ + "static/media/plataforma_taxtura_modal.81a9d4a1.png";